import { zodResolver } from '@hookform/resolvers/zod'
import { toFullName } from '@repo/toolkit/to-full-name'
import { useQuery } from '@tanstack/react-query'
import { useForm } from 'react-hook-form'
import { z, ZodType } from 'zod'

import { getUsers } from '../../../api/user/get-users'
import { RoleEnum } from '../../../lib/types/enums/users/role.enum'
import { AssignCenterEventInput } from '../../../lib/types/models/center-event/center-event-input'
import { BaseFormProps } from '../../../lib/types/utils'
import { getSubmitAction } from '../../../lib/utils/buttons-config/validation-buttons-config'
import { getSelectedOption } from '../../../lib/utils/functions/misc.functions'
import { createNumberSchema } from '../../../lib/utils/validations/int-array-validation'
import { FORM_MODE } from '../../../utils/constants/form.constants'
import Form, { FormControl, FormField, FormItem } from '../../elements/forms/form'
import ControlledSelectInput from '../../elements/inputs/controlled-select-input'
import ValidationButtons from '../../elements/validation-buttons'

type Props = BaseFormProps<AssignCenterEventInput> & {
  className?: string
}

const formSchema: ZodType<AssignCenterEventInput> = z.object({
  assignedToId: createNumberSchema('Assigné à')
})

const AssignCenterEventForm = ({ defaultValues, className, ...validationButtonProps }: Props) => {
  const form = useForm<AssignCenterEventInput>({
    resolver: zodResolver(formSchema),
    defaultValues,
    mode: FORM_MODE
  })

  const { data: users } = useQuery({
    queryKey: ['users', 'admins'],
    queryFn: () => getUsers({ filter: { roles: [RoleEnum.ADMIN] } })
  })

  return (
    <Form form={form}>
      <form onSubmit={form.handleSubmit(getSubmitAction(validationButtonProps.buttonsConfig))}>
        <div className="divide-y divide-white-active">
          <div className={className}>
            <FormField
              control={form.control}
              name={'assignedToId'}
              render={({ field }) => (
                <FormItem className={'flex-1'}>
                  <FormControl>
                    <ControlledSelectInput
                      {...field}
                      required
                      label={'Assigner à'}
                      options={
                        users?.data.map((user) => ({
                          label: toFullName(user.firstName, user.lastName),
                          value: user.id
                        })) ?? []
                      }
                      selectedOption={getSelectedOption(
                        field.value,
                        toFullName(
                          users?.data.find((user) => user.id === field.value)?.firstName,
                          users?.data.find((user) => user.id === field.value)?.lastName
                        )
                      )}
                    />
                  </FormControl>
                </FormItem>
              )}
            />
          </div>
          <div className="pb-6 px-4">
            <ValidationButtons {...validationButtonProps} />
          </div>
        </div>
      </form>
    </Form>
  )
}

export default AssignCenterEventForm
